import { useLang } from "hooks/useLang"
import { IFinalEvent } from "types/event"
import { useState } from "react"
import { AnimatePresence } from "framer-motion"
import CustomImage from "components/atoms/Image/CustomImage"
import GallerySlider from "components/Slider/GallerySlider"

interface IProps {
    event: IFinalEvent
}

const EventGallery = ({ event }: IProps) => {
    const [isClicked, setIsClicked] = useState({
        open: false,
        index: 0,
    })
    const { t } = useLang()

    return (
        <div className="flex flex-col">
            <div className="grid grid-cols-2 gap-2 py-4 md:grid-cols-3 lg:md:grid-cols-4">
                {event?.posters?.map((poster: string, i: number) => (
                    <div
                        key={i}
                        onClick={() =>
                            setIsClicked({
                                open: true,
                                index: i,
                            })
                        }
                        className="relative aspect-video cursor-pointer overflow-hidden rounded-md bg-gray-600 opacity-80 transition-all hover:opacity-100"
                    >
                        <CustomImage
                            key={poster}
                            src={`${process.env.NEXT_PUBLIC_Event_Img_URL}${poster}`}
                            alt={`mini-img-${poster}`}
                            fill
                            style={{
                                objectFit: "cover",
                            }}
                            sizes="50vw"
                        />
                    </div>
                ))}
            </div>

            <AnimatePresence>
                {isClicked.open ? (
                    <GallerySlider
                        images={event?.posters}
                        clickedIndex={isClicked.index}
                        close={() =>
                            setIsClicked({
                                open: false,
                                index: 0,
                            })
                        }
                    />
                ) : null}
            </AnimatePresence>
        </div>
    )
}

export default EventGallery
